$(document).ready(function ($) {
  // Popups
  $('a[data-popup]').on('click', function(e) {
    window.open($(this).attr('href'));
    e.preventDefault();
  });

  // Determine close button label based on lang attribute
  const lang = $('html').attr('lang') || 'en';
  const closeLabel = {
    en: 'Close',
    de: 'Schließen'
  }[lang] || 'Close';

  // Shared Fancybox options
  const fancyboxOptions = {
    maxWidth: 760,
    fitToView: true,
    height: 'auto',
    openEffect: 'fade',
    closeEffect: 'fade',
    wrapCSS: 'popup',
    arrows: false,
    tpl: {
      wrap: '<div class="fancybox-wrap" tabIndex="-1" role="dialog" aria-modal="true"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
      closeBtn: `<a title="${closeLabel}" aria-label="${closeLabel}" class="fancybox-item fancybox-close" href="javascript:;"></a>`
    },
    helpers: {
      overlay: {
        css: {
          "background-color": "rgba(0, 0, 0, 0.5)"
        }
      }
    },
    onUpdate: () => {
      $('.fancybox-inner').height('auto');
    }
  };

  // Fancybox Popup (bootstrap compat)
  $('a[data-toggle="modal"]').fancybox(fancyboxOptions);

  // Fancybox Popup with beforeLoad hook
  $('.modal-popup').fancybox($.extend({}, fancyboxOptions, {
    beforeLoad: function() {
      this.href = `${this.href}?modal=true`;
    }
  }));
});
